export default [
  {
    path: '/order/productList', // 选择产品
    name: 'PRODUCTLIST',
    component: () => import('@/views/order/productList')
  },
  {
    path: '/order/submit', // 提交信息
    name: 'SUBMIT',
    component: () => import('@/views/order/submit'),
    meta: {
      keepAlive: true
    }
  },
  // {
  //   path: '/order/submitConfirmation', // 确认信息
  //   name: 'SUBMITCONFIRMATION',
  //   component: () => import('@/views/order/submitConfirmation')
  // },
  // {
  //   path: '/order/result', // 关注我们
  //   name: 'RESULT',
  //   component: () => import('@/views/order/result')
  // },
  {
    path: '/order/logistics', // 物流信息
    name: 'LOGISTICS',
    component: () => import('@/views/order/logistics'),
    meta: {
      keepAlive: true
    }
  }
  // {
  //   path: '/order/productMealList', // 产品套餐的订单
  //   name: 'PRODUCTMEALLIST',
  //   component: () => import('@/views/order/productMealList')
  // },
  // {
  //   path: '/order/productMealDetail',
  //   name: 'PRODUCTMEALDETAIL',
  //   component: () => import('@/views/order/productMealDetail')
  // }
]



// WEBPACK FOOTER //
// ./src/router/modules/order.js